import { AiFillGold } from "react-icons/ai";
import { FaBuildingColumns, FaCartShopping, FaChartPie, FaEnvelope, FaGem, FaGear, FaIndustry, FaTableCellsLarge, FaUser } from "react-icons/fa6";

const productionLink = (label, path) => ({
    name: "products",
    permission: "1",
    label,
    path,
    disabled: false,
});

export const fallbackProductionSublinks = [
    productionLink("Geral", "/producao"),
    productionLink("Triagem", "/producao/triagem"),
    productionLink("Fundição", "/producao/fundicao"),
    productionLink("Usinagem", "/producao/usinagem"),
    productionLink("Montagem", "/producao/montagem"),
    productionLink("Polimento", "/producao/polimento"),
    productionLink("Banho", "/producao/banho"),
    productionLink("Laser", "/producao/laser"),
    productionLink("Fechamento", "/producao/fechamento"),
    productionLink("Pronto", "/producao/pronto"),
];

export function buildProductionSublinks(steps) {
    if (!Array.isArray(steps) || steps.length === 0) {
        return fallbackProductionSublinks;
    }

    const active = steps
        .filter((step) => step.is_active)
        .slice()
        .sort((a, b) => a.position - b.position);

    return [
        productionLink("Geral", "/producao"),
        ...active.map((step) => productionLink(step.name, `/producao/${step.slug}`)),
        productionLink("Pronto", "/producao/pronto"),
    ];
}

export const navLinks = [
    {
        name: "home_area",
        label: "Painel",
        path: "/",
        icon: FaTableCellsLarge,
        disabled: false
    },
    {
        name: "orders",
        label: "Pedidos",
        icon: FaCartShopping,
        collapse: true,
        disabled: false,
        sublinks: [
            { name: "orders", permission: '3', label: "Novo Pedido", path: "/pedido-novo", disabled: false },
            { name: "orders", permission: '1', label: "Pedidos", path: "/pedidos", disabled: false },
            { name: "orders", permission: '1', label: "Orçamentos", path: "/orcamentos", disabled: false },
            { name: "orders", permission: '1', label: "Formas de Pagamento", path: "/formas-de-pagamento", disabled: false },
            { name: "orders", permission: '1', label: "Grupos de Índices", path: "/grupos-de-indices", disabled: false },
        ],
    },
    {
        name: "production",
        label: "Produção",
        icon: FaIndustry,
        collapse: true,
        disabled: false,
        sublinks: [],
    },
    {
        name: "price",
        label: "Cotação",
        path: "/cotacao",
        icon: AiFillGold,
        disabled: false
    },

    {
        name: "products",
        label: "Produtos",
        icon: FaGem,
        collapse: true,
        disabled: false,
        sublinks: [
            { name: "products", permission: '1', label: "Produtos", path: "/produtos", disabled: false },
            { name: "products", permission: '1', label: "Serviços", path: "/servicos", disabled: false },
            { name: "products", permission: '1', label: "Categorias", path: "/categorias", disabled: false },
            { name: "products", permission: '1', label: "Formatos", path: "/formatos", disabled: false },
            { name: "products", permission: '1', label: "Confortos", path: "/confortos", disabled: false },
            { name: "products", permission: '1', label: "Banhos", path: "/banhos", disabled: false },
            { name: "products", permission: '1', label: "Acab. Externo", path: "/acabamentos-externos", disabled: false },
            { name: "products", permission: '1', label: "Fechos", path: "/fechos", disabled: false },
            { name: "products", permission: '1', label: "Pedras", path: "/pedras", disabled: false },
        ],
    },
    // {
    //     name: "relationship",
    //     label: "Relacionamento",
    //     path: "/relacionamento",
    //     disabled: true,
    //     icon: FaEnvelope,
    // },
    {
        name: "financial",
        label: "Financeiro",
        path: "/financeiro",
        icon: FaChartPie,
    },
    {
        name: "users",
        label: "Usuários",
        path: "/usuarios",
        icon: FaUser,
        disabled: false
    },
    {
        name: "customers",
        label: "Clientes",
        path: "/clientes",
        icon: FaBuildingColumns,
        disabled: false
    },
    {
        name: "logs",
        label: "Configuração",
        icon: FaGear,
        collapse: true,
        disabled: false,
        sublinks: [
            { name: "logs", permission: "1", label: "Casa", path: "/configuracao-casa", disabled: true },
            { name: "logs", permission: "1", label: "Etapas de produção", path: "/configuracao-etapas", disabled: true },
            { name: "logs", permission: "1", label: "Presets de fluxo", path: "/configuracao-presets", disabled: true },
            { name: "logs", permission: "1", label: "Metais", path: "/configuracao-metais", disabled: false },
            { name: "logs", permission: "1", label: "Log de Atividades", path: "/log", disabled: false },
            { name: "logs", permission: "1", label: "Log de Clientes", path: "/log-clientes", disabled: false },
        ],
    },
];
